/**
 * 공용 브라우저 자동완성 배경 차단 클래스.
 * Stencil의 styles/reset.scss + sd-input/sd-barcode-input.scss 규칙과 짝을 이루는 단일 기준이며,
 * 네이티브 <input>·<textarea>를 가진 컴포넌트는 그 요소에 이 클래스를 직접 붙여 쓴다.
 *
 * 자동완성이 걸린 필드에 브라우저가 UA 스타일시트로 파란 배경을 칠한다. 이 배경은
 * background-color로 덮을 수 없어(UA 내부에서 !important로 걸린다), 필드 배경색과 같은 색의
 * 거대한 inset box-shadow로 가리는 것이 유일한 방법이다. transition은 배경 재계산이 뒤늦게
 * 걸리는 경우의 보험으로, 원본 규칙에 있던 것을 그대로 옮겼다.
 *
 * Stencil은 전역 reset.scss로 페이지의 모든 input을 덮지만 이 패키지에는 그럴 자리가 없다 —
 * theme.css는 생성 산출물이라 손댈 수 없고, Tailwind 소비자(theme.css만 import)와 컴파일 CSS
 * 소비자(styles.css) 양쪽에 동시에 닿는 곳은 컴포넌트가 붙이는 유틸 클래스뿐이다.
 *
 * 배경색을 토큰 var()로 참조하는 것이 핵심이다. SBarcodeInput은 래퍼에서
 * --sys-color-field-bg-default를 --cmp-textinput-bg-barcode(노랑)로 재바인딩하므로, 같은
 * 클래스가 바코드 필드에서는 저절로 노란 배경으로 해석된다. Stencil이 sd-input(#fff)과
 * sd-barcode-input(#fafaa1)에 규칙을 통째로 복제해 둔 부분이 여기서는 하나로 합쳐진다.
 * 글자색도 같은 이유로 currentColor를 쓴다 — 각 컴포넌트가 input에 지정한 color를 그대로 따른다.
 *
 * :autofill과 :-webkit-autofill을 각각 따로 적는다. 한쪽 셀렉터를 모르는 브라우저는 그 규칙을
 * 통째로 버리므로 콤마로 묶으면 안 되는데, Tailwind는 클래스마다 규칙을 나누므로 variant를
 * 둘로 적는 것으로 충족된다. Tailwind v4의 autofill: 은 &:autofill만 내보내고 접두사 셀렉터는
 * 만들지 않아, -webkit- 쪽은 arbitrary variant로 직접 적는다.
 *
 * Tailwind는 소스에 문자열로 박힌 클래스만 수집한다. 선언을 배열로 두고 조립하면 스캐너가
 * 보지 못하므로 아래처럼 완성형 클래스를 그대로 나열한다(scrollbar.ts와 같은 이유).
 */
export const AUTOFILL_RESET_CLASS =
  'autofill:[-webkit-text-fill-color:currentColor] ' +
  'autofill:[box-shadow:0_0_0_1000px_var(--sys-color-field-bg-default)_inset] ' +
  'autofill:[transition:background-color_5000s_ease-in-out_0s] ' +
  '[&:-webkit-autofill]:[-webkit-text-fill-color:currentColor] ' +
  '[&:-webkit-autofill]:[box-shadow:0_0_0_1000px_var(--sys-color-field-bg-default)_inset] ' +
  '[&:-webkit-autofill]:[transition:background-color_5000s_ease-in-out_0s]';
